import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { EndpointPermission } from 'src/app/core/models/endpoint-permission';

@Component({
  selector: 'app-endpoint-permission-edit-modal',
  templateUrl: './endpoint-permission-edit-modal.component.html',
  standalone: false,
})
export class EndpointPermissionEditModalComponent implements OnInit {
  // Cópia editável do registro selecionado.
  model: Partial<EndpointPermission> = {};

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    const permission: EndpointPermission | undefined =
      this.config.data?.permission;

    if (permission) {
      this.model = {
        id: permission.id,
        permissionKey: permission.permissionKey,
        displayName: permission.displayName,
        description: permission.description ?? '',
        httpMethod: permission.httpMethod,
        routePath: permission.routePath,
        isActive: permission.isActive,
      };
    }
  }

  close(): void {
    this.ref.close();
  }

  save(form: NgForm): void {
    if (!form.valid) {
      return;
    }

    this.ref.close({
      id: this.model.id,
      displayName: (this.model.displayName || '').trim(),
      description: (this.model.description || '').trim(),
      isActive: this.model.isActive,
    });
  }
}
